import { CountryOptions } from '../data/CountryOptions'

// Fallback list of countries without zipcodes (used if API hasn't loaded yet)
// This should match countries where hasZipcodes: false in /api/v1/tools/countries
const FALLBACK_COUNTRIES_WITHOUT_ZIPCODES = [
    'AE', // United Arab Emirates
    'BH', // Bahrain
    'BO', // Bolivia
    'GH', // Ghana
    'GL', // Greenland
    'GY', // Guyana
    'PA', // Panama
    'SL', // Sierra Leone
    'SR', // Suriname
    'SV', // El Salvador
    'TT', // Trinidad and Tobago
    'TZ', // Tanzania
]

// Get countries without zipcodes from API data, with fallback to hardcoded list
export const getCountriesWithoutZipcodes = (): string[] => {
    // Check if CountryOptions has been updated from API (has hasZipcodes property)
    const hasApiData = CountryOptions.some((c: any) => c.hasZipcodes !== undefined)

    if (hasApiData) {
        // Use API data - filter countries where hasZipcodes is false
        return CountryOptions
            .filter((c: any) => c.hasZipcodes === false)
            .map((c: any) => c.Code)
    }

    // Fallback to hardcoded list if API hasn't loaded yet
    return FALLBACK_COUNTRIES_WITHOUT_ZIPCODES
}

// For backwards compatibility - this will now dynamically get the list
export const COUNTRIES_WITHOUT_ZIPCODES = FALLBACK_COUNTRIES_WITHOUT_ZIPCODES

// Helper function to check if a country has zipcodes
export const countryHasZipcodes = (countryCode: string): boolean => {
    return !getCountriesWithoutZipcodes().includes(countryCode)
}
